module.exports = __webpack_public_path__ + "p1_img3.jpg?92124fccd0b75d7e3fe8ecbb2c1dd467";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p1/p1_img3.jpg
// module id = 113
// module chunks = 0